// extracted by mini-css-extract-plugin
module.exports = {"profile":"Profile_profile__96wcN","tooltip_style":"Profile_tooltip_style__zpn38","profile_dropdown":"Profile_profile_dropdown__Mg9_Y","profile_item":"Profile_profile_item__YY6m1"};